import React from 'react'
import { ChakraProvider } from '@chakra-ui/react'
import { chemistryTheme, Container, Text } from 'chemistry'

export const NotFoundComponent = ({ format, translations }) => {
  return (
    <ChakraProvider resetCSS={false} theme={chemistryTheme}>
      <Container wrapper={{ paddingInline: 0 }}>
        <section className='flex flex-column items-center gap-1 pt4 center'>
          <div className='relative mb3'>
            <img className='fit' src={`https://vdm.praxiscdn.nl/logos/404-${format}.png`} alt='404' title='404' />
            <Text className='flex absolute col-12 justify-center' bottom={0} color='white' fontSize='120px'>
              404
            </Text>
          </div>
          <Text fontWeight='700' fontSize='40px' color='offYellow.500' lineHeight='50px'>
            {translations['404.title'] || '404.title'}
          </Text>
          <Text fontSize='md' color='black.400'>
            {translations['404.description'] || '404.description'}
          </Text>
        </section>
      </Container>
    </ChakraProvider>
  )
}
